import { types } from "../type";

const initialState = {
  accessResponse: "",
  accessError: "",
  accessLoading: false,
  accessCreateLoading: false,
  accessStatus: 0,
  accesses: [],
  allUpdates: null,
  employeeAccesses: [],
  locationId: "",
  selectedAccessModuleInput: ""
};

const accessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AccessTypes.ACCESS_SET_LOADING:
      return {
        ...state,
        accessLoading: action.payload
      };
    case types.AccessTypes.ACCESS_SET_CREATE_LOADING:
      return {
        ...state,
        accessCreateLoading: action.payload
      };
    case types.AccessTypes.ACCESS_CLEAR_ERRORS:
      return {
        ...state,
        accessError: ""
      };
    case types.AccessTypes.SELECTED_MODULE_ACCESS:
      return {
        ...state,
        selectedAccessModuleInput: action.payload
      };
    case types.AccessTypes.ACCESS_GET_ERRORS:
      return {
        ...state,
        accessLoading: false,
        accessCreateLoading: false,
        accessError: action.payload.data.message,
        accessStatus: action.payload.status
      };
    case types.AccessTypes.GET_EMPLOYEE_ACCESS:
      return {
        ...state,
        accessLoading: false,
        employeeAccesses: action.payload
      };
    case types.AuthTypes.ALL_UPDATE:
      return {
        ...state,
        accessLoading: false,
        allUpdates: action.payload.foundUpdates
      };
    case types.AccessTypes.ADD_ACCESS:
      return {
        ...state,
        accessCreateLoading: false,
        accessResponse: action.payload.message,
        accesses: action.payload.accesses
      };
    case types.AuthTypes.ADD_UPDATE:
      return {
        ...state,
        accessLoading: false,
        accessResponse: action.payload.message
      };
    case types.AccessTypes.DELETE_ACCESS:
      return {
        ...state,
        accessResponse: action.payload.message,
        accesses: action.payload.accesses
      };
    case types.AccessTypes.ACCESS_CLEAR_RESULT:
      return {
        ...state,
        accessResponse: ""
      };
    case types.AccessTypes.ACCESS_INPUT:
      return {
        ...state,
        locationId: action.payload.locationId
      };
    case types.AccessTypes.ALL_INPUTS:
      return {
        ...state,
        locationId: action.payload.locationId,
        fromDate: action.payload.fromDate,
        toDate: action.payload.toDate
      };
    case types.AccessTypes.GET_ALL_ACCESS:
      return {
        ...state,
        accessLoading: false,
        accesses: action.payload.accesses
      };
    case types.AccessTypes.CREATE_ACCESS:
      return {
        ...state,
        accessCreateLoading: false,
        accessResponse: action.payload.message
      };
    case types.AccessTypes.ACCESS_UNMOUNT:
      return {
        ...state,
        accesses: [],
        locationId: "",
        fromDate: "",
        toDate: ""
      };
    default:
      return state;
  }
};

export default accessReducer;
